import { Injectable } from '@angular/core';
import { todayLocalDateString, localDateStringPlusDays } from '../core/utils/date.util';


@Injectable({
  providedIn: 'root'
})
export class DateUtilService {

    public readonly dataHoje: string = todayLocalDateString();
    public readonly sevenDaysAgo: string = localDateStringPlusDays(-7);

}
